const localOrPgRegexp = /(localhost|playground|cheggnet)/

export default function isProduction(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  if (!hostname) {
    return false
  }

  return !localOrPgRegexp.test(hostname)
}
